import request from '@/utils/request';

export function login(data) {//例子
    return request({
        url: '/backend/index/login',
        method: 'post',
        data
    })
}


// WEBPACK FOOTER //
// ./src/api/login.js